/* eslint-disable max-len */
import React from 'react';
import { IIconProps } from './types';

function IconDone(props: IIconProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.00006 16.2L5.50006 12.7C5.40853 12.6074 5.29953 12.5338 5.17937 12.4836C5.05921 12.4334 4.93028 12.4076 4.80006 12.4076C4.66983 12.4076 4.5409 12.4334 4.42074 12.4836C4.30058 12.5338 4.19158 12.6074 4.10006 12.7C4.00742 12.7915 3.93387 12.9005 3.88367 13.0207C3.83347 13.1409 3.80762 13.2698 3.80762 13.4C3.80762 13.5302 3.83347 13.6592 3.88367 13.7793C3.93387 13.8995 4.00742 14.0085 4.10006 14.1L8.29006 18.29C8.68006 18.68 9.31006 18.68 9.70006 18.29L20.3001 7.70001C20.3927 7.60848 20.4662 7.49948 20.5164 7.37932C20.5666 7.25916 20.5925 7.13023 20.5925 7.00001C20.5925 6.86978 20.5666 6.74085 20.5164 6.62069C20.4662 6.50053 20.3927 6.39153 20.3001 6.30001C20.2085 6.20737 20.0995 6.13382 19.9794 6.08362C19.8592 6.03342 19.7303 6.00757 19.6001 6.00757C19.4698 6.00757 19.3409 6.03342 19.2207 6.08362C19.1006 6.13382 18.9916 6.20737 18.9001 6.30001L9.00006 16.2Z" fill="#2C3E66" />
    </svg>
  );
}

export default IconDone;
